import { WebPortalService } from "../resource";

const AgentNumberV4Module = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    }
  },
  actions: {
    createData({ commit, state }, data) {
      return WebPortalService.NumberCreateV4(data);
    },
    updateData({ commit, state }, data) {
      return WebPortalService.NumberUpdateV4(data);
    },
    deleteData({ commit, state }, data) {
      return WebPortalService.NumberDeleteV4(data);
    },
    resetPassword({ commit, state }, data) {
      return WebPortalService.resetPasswordNumber(data);
    },
    comPortalLogin({ commit, state }, data) {
      return WebPortalService.ComProtalLogin(data);
    },
    syncPackage({ commit, state }, data) {
      return WebPortalService.SyncPackage(data);
    },
    async listData({ commit, state }) {
      try {
        const data = await WebPortalService.NumberListV4();
        commit("SET_DATA", data.data.Data == null ? [] : data.data.Data);
      } catch {
        commit("SET_DATA", []);
      }
    },
    async listDataByEnterprise({ commit, state }, param) {
      try {
        const data = await WebPortalService.NumberListByEnterpriseV4(param);
        commit("SET_DATA", data.data.Data == null ? [] : data.data.Data);
      } catch {
        commit("SET_DATA", []);
      }
    }
  },
  getters: {
    getData(state) {
      return state.data;
    }
  }
};

export default AgentNumberV4Module;
